function objectToOption(object, indexes, collection) {
  return {
    label:
      indexes
        .filter((i) => object[i])
        .map((i, idx) =>
          idx === 0 && collection === "employees" ? `${object[i]},` : object[i]
        ) // Add a comma after the first value
        .join(" ") || object.id, // Join the values with a space
    value: object.id,
    object: object,
  };
}

export default objectToOption;
